import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./TrustBar.css";

const trustItems = [
  {
    icon: "fa-headset",
    label: "24/7 Dedicated Support",
  },
  {
    icon: "fa-chart-line",
    label: "97% Uptime Target",
  },
  {
    icon: "fa-shield-halved",
    label: "Secure & Reliable",
  },
  {
    icon: "fa-network-wired",
    label: "40 Mbps Network",
  },
];

const TrustBar = () => {
  return (
    <section className="hn-trustbar">
      <Container>
        <Row className="g-4 justify-content-center">
          {trustItems.map((item, idx) => (
            <Col key={idx} xs="12" sm="6" md="3">
              <div className="hn-trustbar-item">
                <i className={`fas ${item.icon} hn-trustbar-icon`} aria-hidden="true" />
                <span className="hn-trustbar-label">{item.label}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default TrustBar;
